import dayjs from 'dayjs';

import { ApplicationPayload } from '~/types/ApplicationPayload';

export type ExpiredDocument = {
  contactType: string;
  contactName: string;
  documentType: string;
  expiryDate: string;
};

const isExpired = (expiryDate?: string): boolean => {
  if (!expiryDate) return false;
  return dayjs(expiryDate).isBefore(dayjs(), 'day');
};

const getContactName = (person: any): string => {
  const name = `${person?.firstName || ''} ${person?.lastName || ''}`.trim();
  return name || person?.email || '-';
};

const getPersonExpiredDocuments = (person: any, contactType: string): ExpiredDocument[] => {
  const documents: ExpiredDocument[] = [];
  const contactName = getContactName(person);

  if (isExpired(person?.emiratesId?.expiryDate)) {
    documents.push({
      contactType,
      contactName,
      documentType: 'Emirates ID',
      expiryDate: person.emiratesId.expiryDate,
    });
  }
  if (isExpired(person?.passport?.expiryDate)) {
    documents.push({
      contactType,
      contactName,
      documentType: 'Passport',
      expiryDate: person.passport.expiryDate,
    });
  }
  return documents;
};

export const getExpiredDocuments = (payload?: ApplicationPayload): ExpiredDocument[] => {
  if (!payload) return [];
  const expired: ExpiredDocument[] = [];

  (payload.authorizedRepresentative || []).forEach((person: any) => {
    expired.push(...getPersonExpiredDocuments(person, 'Authorized Representative'));
  });

  (payload.shareholders?.individuals || []).forEach((item: any) => {
    expired.push(...getPersonExpiredDocuments(item?.data, 'Individual Shareholder'));
  });

  (payload.shareholders?.beneficialOwners || []).forEach((item: any) => {
    expired.push(...getPersonExpiredDocuments(item?.data, 'Beneficial Shareholder'));
  });

  const licenseExpiryDate = payload.companyInformation?.companyLicense?.licenseExpiryDate;
  if (isExpired(licenseExpiryDate)) {
    expired.push({
      contactType: 'Company',
      contactName: payload.companyInformation?.companyLicense?.legalName || '-',
      documentType: 'Trade License',
      expiryDate: licenseExpiryDate as string,
    });
  }

  return expired;
};
